import axios from "axios/index";
import api from "../../config/_api";
import {SENSORS_UPDATED} from "../actions/sensors";
import {isSubscriptionValid} from "../modules/auth";

const state = {
    sensors: []
};
const actions = {
    getSensors: ({commit, rootGetters}) => {
        var option = "";
        if(!isSubscriptionValid()){
            option = "&withMirror=yes";
        }
        axios({url: api.url + 'sensors?structure_id=' + rootGetters.structure_id + "&hasWarning=true"+ option, method: 'GET' })
            .then(resp => {
                commit('SENSORS_UPDATED', resp.data);
            })
            .catch(err => {
               // console.log(err);
            });
    },
    //recupere un sensor
    getSens: ({commit, rootGetters}, payload) => {
        return new Promise((resolve, reject) => {
        axios({url: api.url + 'sensors?structure_id=' + rootGetters.structure_id + "&id=" + payload.id, method: 'GET'})
            .then(resp => {
            commit('SENSORS_UPDATED', resp.data);
            resolve(resp.data); // résoudre la promesse avec la réponse
            })
            .catch(err => {
            reject(err); // rejeter la promesse avec l'erreur
            });
        });
    }
};

const mutations = {
    [SENSORS_UPDATED]: (state, sensors) => {
        state.sensors = sensors;
    },
};
const getters = {
    sensors : state => state.sensors,
};
export default {
    namespaced: true,
    state,
    actions,
    mutations,
    getters
};
//# sourceMappingURL=sensors.js.map